import React, { useEffect, useState } from 'react'
import { Avatar, Pagination, Table, Tooltip } from 'antd';
import "./LeaveRequest.scss";
import { useGetApiRequests } from '../../../common/CommonExport';
import LeaveRequestConfirmation from './LeaveRequestConfirmation';
import { useSelector } from 'react-redux';
const LeaveRequest = ({ policyType }: { policyType?: string }) => {
  const leavePloicyApi = useGetApiRequests('getLeaveRequest', 'POST');
  const [loader, setLoader] = useState(false);
  const [closeConfirmationModal, setCloseConfirmationModal] = useState(false)
  const [leaveRequestList, setLeaveRequestList] = useState<any>([])
  const [type, setType] = useState('');
  const [approvalObject, setApprovalObject] = useState({});
  const userId = useSelector((state: any) => state?.userId?.id);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [count, setCount] = useState<number>(0);

  const onShowSizeChange = (current: number, newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setTimeout(() => {
      const tags = document.getElementsByClassName('ant-table-content');
      if (tags.length > 1) {
        tags[1].scrollTop = 0;
      }
      getLeavePolicyApi()
    }, 100);
  }, [currentPage, pageSize, policyType]);

  const regularDateConversion = (value: any) => {
    const apiDate = new Date(value);
    const year = apiDate.getFullYear();
    const month = String(apiDate.getMonth() + 1).padStart(2, "0");
    const day = String(apiDate.getDate()).padStart(2, "0");

    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
  }
  const getLeaveNames = (fullName: string): string => {
    const words = fullName?.split(' ');
    if (words?.length >= 2) {
      const firstNameInitial = words[0][0].toUpperCase();
      const lastNameInitial = words[words?.length - 1][0].toUpperCase();
      return `${firstNameInitial}${lastNameInitial}`;
    } else if (words?.length === 1) {
      return words[0][0].toUpperCase();
    } else {
      return '';
    }
  };

  const formatLeaveTypeName = (leaveTypeName: string | null | undefined): string => {
    if (!leaveTypeName) return '';
    return leaveTypeName.trim().toUpperCase() === 'WFH' ? 'Work From Home' : leaveTypeName;
  };
  const handleApprove = (record: any, type: any) => {
    setApprovalObject(record)
    setCloseConfirmationModal(true);
    setType(type)
  }
  const handleCloseModal = () => {
    setType('')
    setCloseConfirmationModal(false)
  }
  function capitalizeFirstLetter(inputText: any) {
    if (!inputText) return '';
    return inputText.charAt(0).toUpperCase() + inputText.slice(1);
  };

  const computeLeaveTimeFormat = (totalLeaveHours: number): string => {
    const hoursValue = Math.floor(totalLeaveHours);
    const minutesValue = Math.round((totalLeaveHours - hoursValue) * 60);

    const normalizedHours = minutesValue === 60 ? hoursValue + 1 : hoursValue;
    const normalizedMinutes = minutesValue === 60 ? 0 : minutesValue;

    return `${normalizedHours}h ${normalizedMinutes}m`;
  };


  const columns: any = [
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      key: 'employeeName',
    },
    {
      title: 'Types',
      dataIndex: 'leaveType',
      key: 'leaveType',
      render: (text: any) => {
        const displayLeaveType = formatLeaveTypeName(text);
        return (
          <div className='flex items-center leave-type'>
            <Avatar.Group maxCount={3} maxPopoverTrigger="click" size="large" maxStyle={{ color: '#f56a00', backgroundColor: '#fde3cf', cursor: 'pointer' }}>
              <Avatar className={"leave-type-" + text}>{getLeaveNames(displayLeaveType)}</Avatar>
            </Avatar.Group>
            <p className='ml-2'>{displayLeaveType}</p>
          </div>
        )
      },
    },
    {
      title: 'From ',
      dataIndex: 'fromDate',
      key: 'fromDate',
    },
    {
      title: 'To ',
      dataIndex: 'toDate',
      key: 'toDate',
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (text: any, record: any) => {
        return (
          <div className="flex items-center space-x-1 ml-2">
            <p className="flex items-center">
              {["Permission", "On duty"].includes(record?.leaveType)
                ? computeLeaveTimeFormat(text)
                : `${text}d`}
            </p>

            {record?.lopCount > 0 && (
              <p className="text-red-400 text-[13px]">
                (LOP - <span>{record?.lopCount}</span>)
              </p>
            )}
          </div>
        );
      },
    }
    ,
    {
      title: 'Status ',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, record: any) => (
        <div className='flex'>
          <p><span className={"mr-2 leave-request-" + record?.status}></span>{record?.status}</p>
        </div>
      ),
    },
    {
      title: 'Reason ',
      dataIndex: 'reason',
      key: 'reason',
      render: (_: any, record: any) => (
        <div className='flex'>
          <p><span className={" leave-request " + record?.reason}></span>{record?.reason}</p>
        </div>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'action',
      key: 'action',
      render: (_: any, record: any) => (
        <div className='flex'>
          {record.status === 'pending' || record.status === 'Pending' ? (
            <div>
              <Tooltip placement="top" title="Approve">
                <span className="material-symbols-outlined  cursor-pointer hover:text-green-500" onClick={() => handleApprove(record, 'approve')}>done</span>
              </Tooltip>
              <Tooltip placement="top" title="Decline">
                <span className="material-symbols-outlined cursor-pointer hover:text-red-500" onClick={() => handleApprove(record, 'decline')}>close</span>
              </Tooltip>
            </div>) : (record.status === 'approved' || record.status === 'Approved') ? (
              <div>
                <Tooltip placement="top" title="Approved">
                  <span className="material-symbols-outlined  text-green-500">done</span>
                </Tooltip>
              </div>
            ) : (
            <div>
              <Tooltip placement="top" title="Declined">
                <span className="material-symbols-outlined  text-red-500">close</span>
              </Tooltip>
            </div>
          )}
        </div>
      )
    }];

  const getLeavePolicyApi = () => {
    const start: number = currentPage - 1 === 0 ? 0 : currentPage - 1;
    setLoader(true);
    const payload = {
      "searchEmployeeLeaveDto": {
        "employeeId": userId
      },
      start: start * 10,
      limit: pageSize,
      "sortBy": "employeeLeavePolicyRequestMapId",
      "sortDirection": "DESC"
    }
    leavePloicyApi(payload)
      .then((response: any) => {
        const reformedRequestList = response?.data?.data.map((item: any) => ({
          leaveType: item?.policyType,
          employeeName: item?.employeeName,
          fromDate: regularDateConversion(item?.fromDate),
          toDate: regularDateConversion(item?.toDate),
          duration: item?.duration,
          status: capitalizeFirstLetter(item?.status),
          reason: item?.reason,
          key: item?.employeeLeaveRequestId,
          from: item?.fromDate,
          to: item?.toDate,
          lopCount: item?.lopCount
        }));

        const onDutyTypes = ["Client Visit", "WFH"];
        const filteredList = policyType
          ? reformedRequestList.filter((item: any) => onDutyTypes.includes(item.leaveType))
          : reformedRequestList.filter((item: any) => !onDutyTypes.includes(item.leaveType));

        setLeaveRequestList(filteredList);
        setCount(filteredList.length || 0);
        setTimeout(() => {
          setLoader(false)
        }, 1000)
      })
      .catch(() => {
        setTimeout(() => {
          setLoader(false)
        }, 1000)
      });
  }
  return (
    <div className='leave-report leave-request'>
      <Table columns={columns} dataSource={leaveRequestList} loading={loader} pagination={false} />
      <div className='pagination'>
        <Pagination
          className='float-right flex flex-row p-6'
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          current={currentPage}
          total={count}
          pageSize={pageSize}
          onChange={(page) => setCurrentPage(page)}
        />
      </div>
      {closeConfirmationModal && <LeaveRequestConfirmation approvalObject={approvalObject} closeConfirmationModal={closeConfirmationModal} setCloseConfirmationModal={setCloseConfirmationModal} type={type} handleCloseModal={handleCloseModal} setType={setType} getLeavePolicyApi={getLeavePolicyApi} />}
    </div>
  )
}

export default LeaveRequest
